import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";

const CookiePolicy = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      
      <main className="pt-32 pb-20">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto">
            <h1 className="text-4xl font-bold mb-4">Cookie Policy</h1>
            <p className="text-muted-foreground mb-12">Last updated: January 2026</p>
            
            <div className="prose prose-neutral dark:prose-invert max-w-none space-y-8">
              <section>
                <h2 className="text-2xl font-semibold mb-4">1. What Are Cookies?</h2>
                <p className="text-muted-foreground leading-relaxed">
                  Cookies are small text files that are stored on your device (computer, tablet, or mobile phone) when you visit a website. They help the website remember your preferences and understand how you use the site. Cookies are widely used to make websites work more efficiently and provide information to website owners.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">2. How We Use Cookies</h2>
                <p className="text-muted-foreground leading-relaxed mb-4">CallChat uses cookies for the following purposes:</p>
                <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                  <li><strong>Essential Cookies:</strong> Required for the website to function properly. These enable core functionality such as security, authentication, and session management.</li>
                  <li><strong>Functional Cookies:</strong> Allow us to remember your preferences and personalize your experience, such as your language preference or login status.</li>
                  <li><strong>Analytics Cookies:</strong> Help us understand how visitors interact with our website by collecting anonymous usage data. We use this to improve our service.</li>
                  <li><strong>Marketing Cookies:</strong> Used to track visitors across websites to display relevant advertisements. These are only used with your consent.</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">3. Types of Cookies We Use</h2>
                
                <div className="space-y-6">
                  <div className="p-4 rounded-lg bg-muted">
                    <h3 className="font-semibold mb-2">Essential Cookies</h3>
                    <p className="text-sm text-muted-foreground mb-2">These cookies are strictly necessary and cannot be disabled.</p>
                    <ul className="text-sm text-muted-foreground space-y-1">
                      <li>• Session cookies (session management)</li>
                      <li>• Authentication cookies (login status)</li>
                      <li>• Security cookies (CSRF protection)</li>
                    </ul>
                  </div>

                  <div className="p-4 rounded-lg bg-muted">
                    <h3 className="font-semibold mb-2">Analytics Cookies</h3>
                    <p className="text-sm text-muted-foreground mb-2">Help us understand website usage patterns.</p>
                    <ul className="text-sm text-muted-foreground space-y-1">
                      <li>• Google Analytics (anonymous usage data)</li>
                      <li>• Performance monitoring tools</li>
                    </ul>
                  </div>

                  <div className="p-4 rounded-lg bg-muted">
                    <h3 className="font-semibold mb-2">Functional Cookies</h3>
                    <p className="text-sm text-muted-foreground mb-2">Remember your preferences for a better experience.</p>
                    <ul className="text-sm text-muted-foreground space-y-1">
                      <li>• Language preference</li>
                      <li>• Display settings</li>
                      <li>• Dashboard customizations</li>
                    </ul>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">4. Cookie Retention</h2>
                <p className="text-muted-foreground leading-relaxed">
                  Cookies have varying lifespans. Session cookies are deleted when you close your browser. Persistent cookies remain on your device for a set period (typically 30 days to 2 years) or until you delete them manually.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">5. Managing Your Cookie Preferences</h2>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  You have several options for managing cookies:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                  <li><strong>Browser Settings:</strong> Most browsers allow you to block or delete cookies through their settings menu.</li>
                  <li><strong>Cookie Consent:</strong> When you first visit our website, you can choose which types of cookies to accept through our cookie consent banner.</li>
                  <li><strong>Opt-Out Links:</strong> For analytics cookies, you can use opt-out tools provided by analytics providers (e.g., Google Analytics Opt-out).</li>
                </ul>
                <p className="text-muted-foreground leading-relaxed mt-4">
                  Note: Blocking essential cookies may prevent you from accessing certain features of our website.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">6. Third-Party Cookies</h2>
                <p className="text-muted-foreground leading-relaxed">
                  Some cookies are placed by third-party services that appear on our pages. We do not control these cookies. Third-party providers include analytics services and social media platforms. Please refer to their respective privacy policies for information on how they use cookies.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">7. Updates to This Policy</h2>
                <p className="text-muted-foreground leading-relaxed">
                  We may update this Cookie Policy from time to time to reflect changes in our practices or applicable laws. We will notify you of significant changes by posting a notice on our website.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">8. Contact Us</h2>
                <p className="text-muted-foreground leading-relaxed">
                  If you have questions about our use of cookies, please contact us at:
                </p>
                <div className="mt-4 p-4 rounded-lg bg-muted">
                  <p className="text-sm">Email: privacy@callchat.eu</p>
                  <p className="text-sm">Address: Brussels, Belgium</p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default CookiePolicy;
